import { useQuery } from '@tanstack/react-query';
import { $apiFetchClient } from 'src/services/api';

export interface CodCurrency {
  id: number;
  code: string;
  name: string;
}

export interface CodSettings {
  enabled: boolean;
  currencies: CodCurrency[];
}

// Endpoint existiert im Backend-Branch, ist aber noch nicht in den generierten
// Typen (openapi-Regeneration folgt nach Backend-Restore) — daher untyped GET
// mit lokalem Interface statt $api.useQuery (Übergangsmuster, s. incoterm.ts).
export const useCodSettingsQuery = () =>
  useQuery({
    queryKey: ['get', '/sale_orders/cod_settings/'],
    queryFn: async () => {
      const response = await ($apiFetchClient as { GET: Function }).GET('/sale_orders/cod_settings/', {});
      if (response.error) throw response.error;
      return (response.data ?? { enabled: false, currencies: [] }) as CodSettings;
    },
    staleTime: 5 * 60 * 1000,
  });
